export default __webpack_public_path__ + "static/media/forms.8a46a672.svg";